import React from 'react';
import PropTypes from 'prop-types'
import Icon from 'bui/ui/Icon'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment'
import defaultRanges from './default-ranges'

export default class BlankDatePicker extends React.Component {
  static propTypes = {
    ranges: PropTypes.object,
  }

  static defaultProps = {
    ranges: defaultRanges,
  }

  constructor(props) {
    super(props)

    this.handleEvent = this.handleEvent.bind(this)
    this.handleClearValue = this.handleClearValue.bind(this)

    if (props.start) this.state.startDate = moment(props.start, 'MM/DD/YYYY')
    if (props.end) this.state.endDate = moment(props.end, 'MM/DD/YYYY')
  }

  state = {
    // startDate: moment().subtract(29, 'days'),
    // endDate: moment(),
  }

  handleEvent(e, picker) {
    if (e.type === 'show' || e.type === 'hide') {
      return;
    }
    this.setState({
      startDate: picker.startDate,
      endDate: picker.endDate,
    })
  }

  handleClearValue() {
    this.setState({
      startDate: null,
      endDate: null,
    })
  }

  get label() {
    const { startDate, endDate } = this.state
    if (!startDate && !endDate) return '' // return 'No Date Selected'

    const start = startDate.format('MM/DD/YYYY');
    const end = endDate ? endDate.format('MM/DD/YYYY') : null;

    let label = `${start} - ${end}`
    if (start === end || !end) {
      label = start
    }

    return label
  }

  get value() {
    const { startDate, endDate } = this.state
    if (!startDate && !endDate) return ''

    const start = startDate.format('MM/DD/YYYY');
    const end = endDate ? endDate.format('MM/DD/YYYY') : null;

    return `${start} - ${end}`
  }

  render() {
    const { start, end, ranges, ...rest } = this.props
    const isEmpty = !this.value

    return (
      <div className="form-control" style={{ position: 'relative' }}>
        <input type="hidden" {...rest} value={this.value} />

        <DateRangePicker
          onEvent={this.handleEvent}
          ranges={this.props.ranges}
          opens="left"
          linkedCalendars={false}
          showDropdowns
        >
          <div style={{ minWidth: 100 }}>
            <span style={{ paddingRight: 26 }}>{this.label}</span>
          </div>
        </DateRangePicker>
        <Icon
          name="times"
          onClick={this.handleClearValue}
          style={{
            borderLeft: '1px solid #ddd',
            cursor: 'pointer',
            display: isEmpty ? 'none' : 'inline-block',
            padding: 8,
            position: 'absolute',
            right: 2,
            top: '50%',
            transform: 'translateY(-50%)',
          }}
          title="Clear field"
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/elements/date-range/DatePicker.js